import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

class LenisManager {
  constructor() {
    this.lenis = null;
    this.isInitialized = false;
  }

  init() {
    if (this.isInitialized) return this.lenis;

    
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
      prevent: (node) => {
        
        return (
          node.closest('.cart-drawer__content') ||
          node.closest('.mobile-nav__content') ||
          node.closest('[data-lenis-prevent]')
        );
      },
    });

    
    this.lenis.on('scroll', ScrollTrigger.update);

    
    gsap.ticker.add((time) => {
      this.lenis.raf(time * 1000);
    });

    
    gsap.ticker.lagSmoothing(0);

    
    document.documentElement.classList.add('lenis');

    this.isInitialized = true;

    return this.lenis;
  }

  
  scrollTo(target, options = {}) {
    if (!this.lenis) return;

    const defaultOptions = {
      offset: 0,
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      immediate: false,
      lock: false,
      onComplete: null,
    };

    this.lenis.scrollTo(target, { ...defaultOptions, ...options });
  }

  
  stop() {
    if (this.lenis) {
      this.lenis.stop();
    }
  }

  
  start() {
    if (this.lenis) {
      this.lenis.start();
    }
  }

  
  resize() {
    if (this.lenis) {
      this.lenis.resize();
    }
  }

  
  destroy() {
    if (this.lenis) {
      this.lenis.destroy();
      this.lenis = null;
      this.isInitialized = false;
      document.documentElement.classList.remove('lenis');
    }
  }

  
  get scroll() {
    return this.lenis?.scroll || 0;
  }

  
  get progress() {
    return this.lenis?.progress || 0;
  }

  
  get isScrolling() {
    return this.lenis?.isScrolling || false;
  }
}

export const lenisManager = new LenisManager();
export default lenisManager;
